"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  number: "01",
  title: "Jornada Prateada",
  description: "Programa de mentoria em grupo focado em autoconhecimento, planejamento de carreira e longevidade para profissionais 45+.",
  image: "",
  srcset: "",
  sizes: "",
  hasImage: false
}, {
  number: "02",
  title: "Jornada Prateada POCKET",
  description: "Versão intensiva e compacta da Jornada Prateada, ideal para quem busca insights rápidos e ferramentas práticas de transição.",
  image: "",
  srcset: "",
  sizes: "",
  hasImage: false
}, {
  number: "03",
  title: "Jornada Prateada ADVANCED",
  description: "Mentoria individual e personalizada para executivos C-Level que buscam reposicionamento estratégico ou atuação em conselhos.",
  image: "",
  srcset: "",
  sizes: "",
  hasImage: false
}, {
  number: "04",
  title: "Jornada Prateada EAD",
  description: "Nossa metodologia completa em formato digital, permitindo flexibilidade total para o desenvolvimento da sua longevidade profissional.",
  image: "",
  srcset: "",
  sizes: "",
  hasImage: false
}, {
  number: "05",
  title: "Jornada Liderança Prateada",
  description: "Capacitação para líderes que desejam gerir equipes multigeracionais com eficiência, combatendo o etarismo no ambiente corporativo.",
  image: "",
  srcset: "",
  sizes: "",
  hasImage: false
}, {
  number: "06",
  title: "Jornada Líderes Protagonistas",
  description: "Desenvolvimento de competências de liderança para profissionais que buscam assumir o controle de sua trajetória e impacto organizacional.",
  image: "",
  srcset: "",
  sizes: "",
  hasImage: false
}, {
  number: "07",
  title: "Jornada Líderes Integradores",
  description: "Foco em soft skills e inteligência emocional para líderes que precisam conectar áreas, pessoas e propósitos em cenários complexos.",
  image: "",
  srcset: "",
  sizes: "",
  hasImage: false
}, {
  number: "08",
  title: "Rede MasterPro",
  description: "Comunidade exclusiva de networking e atualização contínua para egressos de nossas jornadas e parceiros estratégicos.",
  image: "",
  srcset: "",
  sizes: "",
  hasImage: false
}];
const headlineWords = ["NOSSOS", "SERVIÇOS"];
function RevealWords({
  words,
  className,
  italicFrom
}: {
  words: string[];
  className?: string;
  italicFrom?: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  return <h2 ref={ref} className={className}>
      {words.map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-baseline">
          <span className={`inline-block transition-all duration-700 ease-out ${italicFrom !== undefined && i >= italicFrom ? "italic font-light" : ""} ${isVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`} style={{
        transitionDelay: `${i * 120}ms`
      }}>
            {word}
            {i < words.length - 1 ? "\u00A0" : ""}
          </span>
        </span>)}
    </h2>;
}
function PillarCard({
  pillar,
  index
}: {
  pillar: (typeof pillars)[number];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div ref={ref} data-index={index} className={`group relative bg-card border border-border rounded-lg p-10 md:p-14 transition-all duration-700 ease-out hover:-translate-y-1 hover:shadow-2xl ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDelay: `${index * 100}ms`
  }}>
      <div className="flex items-center gap-5 mb-8">
        <span className="font-serif italic text-7xl md:text-8xl leading-none" style={{
        color: "var(--primary)"
      }}>
          {pillar.number}
        </span>
        <span className="h-px flex-1 max-w-[140px]" style={{
        backgroundColor: "var(--primary)",
        opacity: 0.3
      }} />
      </div>

      <h3 className="font-serif font-default text-3xl md:text-4xl text-foreground leading-tight mb-5">
        {pillar.title}
      </h3>

      <p className="font-default text-base md:text-lg text-muted-foreground leading-relaxed mb-8 max-w-prose">
        {pillar.description}
      </p>

      {pillar.hasImage && pillar.image && <div className="mb-8 overflow-hidden rounded-md">
          <img src={pillar.image} data-wvc-srcset={pillar.srcset} data-wvc-sizes={pillar.sizes} alt={pillar.title} loading="lazy" decoding="async" className="w-full h-48 md:h-64 object-cover transition-transform duration-700 group-hover:scale-105" />
        </div>}

      <Link to="https://wa.me/5511966187866" newTab className="inline-flex items-center gap-2 font-serif italic text-base text-foreground relative w-fit">
        <span className="relative">
          Saiba mais
          <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-foreground transition-all duration-500 group-hover:w-full" />
        </span>
        <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" />
      </Link>
    </div>;
}
export default function Masterproservices() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return;
}